import { ofetch } from "ofetch";
import {
  licencieAnonymousCreate,
  licencieControlEmailUsage,
  licencieSuppressionLicencie,
  utilisateurCheckIfExistByIdentifiant,
  utilisateurGetUserByNumeroChrono,
  type Licencie,
} from "../isia";

export async function getUserIdFromLicenseNumber(licenseNumber: string): Promise<string | null> {
  const numberChrono = licenseNumber.split("-").at(-1);
  if (!numberChrono) throw new Error("Numéro de licence invalide");
  return utilisateurGetUserByNumeroChrono({
    path: { NumeroChrono: numberChrono },
  }) as unknown as Promise<string | null>;
}

// `ssoServer` est passé explicitement (web: runtimeConfig.public.SSO_SERVER,
// mobile: NUXT_PUBLIC_SSO_SERVER) : le package n'a pas accès aux auto-imports Nuxt.
export async function initResetPassword(ssoServer: string, userId: string) {
  const url = new URL(`${ssoServer}api/Users/ResetPassword?username=${userId}`);
  return ofetch(url.toString(), { method: "GET" });
}

export async function changePassword(ssoServer: string, userId: string, password: string, code: string): Promise<void> {
  const url = new URL(`${ssoServer}api/Users/ResetPassword`);
  return ofetch(url.toString(), {
    method: "POST",
    query: { Username: userId, Password: password, Code: code },
  });
}

export async function checkIfIdentifierExists(userId: string): Promise<boolean> {
  return utilisateurCheckIfExistByIdentifiant({
    query: { identifiant: userId },
  }) as unknown as Promise<boolean>;
}

export async function checkIfEmailExists(email: string): Promise<boolean> {
  return licencieControlEmailUsage({ body: email }) as unknown as Promise<boolean>;
}

export async function createUser(user: Licencie) {
  return licencieAnonymousCreate({ body: user });
}

export async function deleteUser(userId: string) {
  return licencieSuppressionLicencie({ path: { licencieid: userId } });
}
